import { useMutation, UseMutationResult } from '@tanstack/react-query';

import { cancelAppointment } from '@modules/genetic-counseling/services';
import { CANCEL_APPOINTMENT_QUERY_KEY } from '../constants';
import {
  CancelAppointmentFormValuesContext,
  CancelAppointmentFormValuesVariables,
  CancelAppointmentResponse,
} from '../types';

function useMutationCancelAppointment(
  onSuccess: (appointmentID: string | undefined, variables: CancelAppointmentFormValuesVariables) => void,
  onError?: (err: any) => any,
): UseMutationResult<
  CancelAppointmentResponse,
  unknown,
  CancelAppointmentFormValuesVariables,
  CancelAppointmentFormValuesContext
> {
  const mutationFn = async ({
    id,
    reason,
    reasonDescription,
    otherReason,
  }: CancelAppointmentFormValuesVariables): Promise<any> => {
    return await cancelAppointment(id, {
      reasonCode: reason,
      reasonDescription,
      declinedReasonNotes: otherReason,
    });
  };

  const onMutateFn = async (): Promise<any> => {};

  const onErrorFn = (
    err: unknown,
    _variables: CancelAppointmentFormValuesVariables,
    _context: CancelAppointmentFormValuesContext | undefined,
  ): void => {
    onError?.(err);
  };

  const onSettledFn = async (): Promise<void> => {};

  const onSuccessFn = async (
    data: CancelAppointmentResponse,
    variables: CancelAppointmentFormValuesVariables,
    _context: CancelAppointmentFormValuesContext | undefined,
  ): Promise<void> => {
    onSuccess?.(data?.appointmentID, variables);
  };

  return useMutation<
    CancelAppointmentResponse,
    unknown,
    CancelAppointmentFormValuesVariables,
    CancelAppointmentFormValuesContext
  >([CANCEL_APPOINTMENT_QUERY_KEY], mutationFn, {
    onMutate: onMutateFn,
    // If the mutation fails, use the context returned from onMutate to roll back
    onError: onErrorFn,
    // Always refetch after error or success:
    onSettled: onSettledFn,
    onSuccess: onSuccessFn,
  });
}

export default useMutationCancelAppointment;
